import { render, staticRenderFns } from "./AddDrug.vue?vue&type=template&id=a7037b46&scoped=true"
import script from "./AddDrug.vue?vue&type=script&lang=js"
export * from "./AddDrug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7037b46",
  null
  
)

export default component.exports